import { motion } from "framer-motion";
import React from "react";
import { FaGithub, FaInstagram, FaLinkedin } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="py-4 mt-5" style={{ backgroundColor: "#1e283c", color: "white" }}>
            <div className="container text-center">
                {/* Animated text */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    © {new Date().getFullYear()} <strong>Madiha Fatima</strong>
                </motion.div>

                {/* Social links */}
                <motion.div
                    className="mt-3 d-flex justify-content-center gap-4"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ delay: 0.3, duration: 0.6 }}
                >
                    <a
                        href="https://github.com/madihamalghani"
                        target="_blank"
                        rel="noreferrer"
                        className="text-white fs-4"
                    >
                        <FaGithub className="hover-icon" />
                    </a>
                    <a
                        href="https://www.linkedin.com/in/madiha-fatima-6762142b4/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-white fs-4"
                    >
                        <FaLinkedin className="hover-icon" />
                    </a>
                    <a
                        href="https://www.instagram.com/madiha_malghani/profilecard/?igsh=MTQ2Z2Nrc2Z4cnplYw=="
                        target="_blank"
                        rel="noreferrer"
                        className="text-white fs-4"
                    >
                        <FaInstagram className="hover-icon" />
                    </a>
                </motion.div>
            </div>
        </footer>
    );
};

export default Footer;
